// Formatage partagé par le TRACÉ et par le TABLEAU qui le double (plan 12/09, C1).
//
// Un seul formateur, délibérément : le tableau n'est pas une seconde présentation des
// données, c'est la MÊME — « 1 234 » doit s'y lire exactement comme sur le graphique et
// dans l'infobulle. Un second `toLocaleString` posé ailleurs aurait fini par diverger
// (c'est l'argument déjà écrit au-dessus de `fmt` dans `components.tsx`, le 12/08).

/** Nombre en français : espace fine insécable aux milliers, virgule décimale. */
export const fmtFr = (v: number): string => v.toLocaleString('fr-FR')

/** Part de `v` dans `total`, au dixième — l'arrondi des proportions acté S4-3 (26/07). */
export const fmtPart = (v: number, total: number): string =>
  (total ? (100 * v) / total : 0).toLocaleString('fr-FR', { maximumFractionDigits: 1 })

/** L'unité exprime-t-elle DÉJÀ une proportion ? (revue codex P2 du 12/09)
 *
 *  La question n'est pas cosmétique. Sur un anneau à valeurs absolues (des arrêtés, des
 *  établissements), calculer la part de chaque arc dans le total est légitime : c'est la
 *  somme des données servies, et c'est ce que l'infobulle ajoute déjà (« 12 sur combien ? »).
 *  Sur un anneau dont les données SONT des pourcentages, la même opération fabrique un
 *  chiffre : elle divise des parts arrondies par la somme de ces arrondis, et affiche un
 *  second pourcentage qui peut ne pas être celui que le producteur a servi. La doctrine du
 *  dépôt l'interdit — on n'affiche que la donnée servie, jamais une valeur dérivée au rendu.
 *
 *  Couvre « % », « % des résidences principales », « ‰ » : tout ce qui commence par un
 *  signe de proportion. Une unité comme « ha » ou « € » n'en est pas une, et son total
 *  garde un sens — la part y reste calculable. */
export const estProportion = (unite?: string): boolean => !!unite && /^\s*[%‰]/.test(unite)

/** A13 (plan 12/09) — une catégorie SANS LIBELLÉ, nommée plutôt que laissée anonyme.
 *
 *  Constat : le graphique « Public / privé par type » d'Éducation servait à Bordeaux
 *  (33063) les catégories `["Ecole", "Collège", "Lycée", "Service Administratif", null,
 *  "Médico-social"]`. Chart.js réserve une colonne pour ce `null` et n'écrit aucun tick :
 *  à l'écran, un blanc s'ouvre entre « Service Administratif » et « Médico-social » — ce
 *  que Marc a signalé comme un espacement cassé. Ce n'était pas l'espacement, c'était une
 *  catégorie fantôme.
 *
 *  On la NOMME au lieu de la retirer. La retirer serait le geste tentant et le mauvais :
 *  cette catégorie porte 7 établissements privés réels, et les effacer ferait mentir le
 *  total de la commune. Le trou est dans la source, il doit rester visible.
 *
 *  ⚠️ Ceci est le filet de rendu, pas le correctif. La cause est en amont, dans la
 *  construction de `edu_equipements` (`builders_vie.py`), qui laisse passer une `nature`
 *  nulle : c'est décrit dans la PR à l'intention du lot A-back-2.
 */
export const CATEGORIE_SANS_NOM = 'Non renseigné'

export const libelleCategorie = (l: string | number | null | undefined): string => {
  const s = l === null || l === undefined ? '' : String(l).trim()
  return s === '' ? CATEGORIE_SANS_NOM : s
}
